import { Component, Input } from "@angular/core";
import { ClassField } from "@node_modules/@angular/compiler/src/output/output_ast";
@Component({
    selector:'QrMena-toaster',
    templateUrl:"./toaste.html"
})
export class QRMenaToasterComponent{
    @Input()Message:string
    @Input() show:boolean
    @Input() issuccess:boolean


}


// WEBPACK FOOTER //
// ./src/QrMena/components/toaster/toaste.ts